"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var defaultMathSymbols_1 = __importDefault(require("./helpers/defaultMathSymbols"));
var unitRegExp = /((?!\w)a|na|hc|mc|dg|me[r]?|xe|ni(?![a-zA-Z])|mm|cp|tp|xp|q(?!s)|hv|xamv|nimv|wv|sm|s(?!\D|$)|ged|darg?|nrut)/g;
function mergeSymbolMaps(additionalSymbols) {
    var symbolMap = {};
    symbolMap.symbols = additionalSymbols
        ? __assign(__assign({}, defaultMathSymbols_1.default.symbols), additionalSymbols.symbols) : __assign({}, defaultMathSymbols_1.default.symbols);
    return symbolMap;
}
function exec(operators, values) {
    var op = operators.pop();
    values.push(op.f.apply(op, [].concat.apply([], values.splice(-op.argCount))));
    return op.precedence;
}
function calculate(expression, additionalSymbols) {
    var symbolMap = mergeSymbolMaps(additionalSymbols);
    var match;
    var operators = [symbolMap.symbols['('].prefix];
    var values = [];
    var pattern = new RegExp("\\d+(?:\\.\\d+)?|" + Object.keys(symbolMap.symbols)
        .map(function (key) { return symbolMap.symbols[key]; })
        .sort(function (a, b) { return b.symbol.length - a.symbol.length; })
        .map(function (val) { return val.regSymbol; })
        .join('|') + "|(\\S)", 'g');
    pattern.lastIndex = 0;
    var afterValue = false;
    do {
        match = pattern.exec(expression);
        var _a = match || [')', undefined], token = _a[0], bad = _a[1];
        var notNumber = symbolMap.symbols[token];
        var notNewValue = notNumber && !notNumber.prefix && !notNumber.func;
        var notAfterValue = !notNumber || (!notNumber.postfix && !notNumber.infix);
        if (bad || (afterValue ? notAfterValue : notNewValue)) {
            throw new Error('Syntax Error');
        }
        if (afterValue) {
            var curr = notNumber.postfix || notNumber.infix;
            do {
                var prev = operators[operators.length - 1];
                if ((curr.precedence - prev.precedence || prev.rightToLeft) > 0)
                    break;
            } while (exec(operators, values));
            afterValue = curr.notation === 'postfix';
            if (curr.symbol !== ')') {
                operators.push(curr);
                if (afterValue)
                    exec(operators, values);
            }
        }
        else if (notNumber) {
            operators.push(notNumber.prefix || notNumber.func);
            if (notNumber.func) {
                match = pattern.exec(expression);
                if (!match || match[0] !== '(') {
                    throw new Error('Formula contains a function that needs parentheses ');
                }
            }
        }
        else {
            values.push(+token);
            afterValue = true;
        }
    } while (match && operators.length);
    if (operators.length) {
        throw new Error('Formula is missing closing parenthesis');
    }
    else if (match) {
        throw new Error('Formula has too many closing parentheses');
    }
    else {
        return values.pop();
    }
}
function reverseString(str) {
    return str
        .split('')
        .reverse()
        .join('');
}
function math(formula, additionalSymbols) {
    var reversedFormula = reverseString(formula);
    var formulaMatch = reversedFormula.match(unitRegExp);
    if (formulaMatch && !formulaMatch.every(function (unit) { return unit === formulaMatch[0]; })) {
        throw new Error('All values in a formula must have the same unit or be unitless.');
    }
    var cleanFormula = reverseString(reversedFormula.replace(unitRegExp, ''));
    return "" + calculate(cleanFormula, additionalSymbols) + (formulaMatch ? reverseString(formulaMatch[0]) : '');
}
exports.default = math;
//# sourceMappingURL=math.js.map